import React, { useContext, useEffect, useState } from 'react'

import TRow from './TRow'

import TableContext from './TContext';
import { useNavigate, useParams } from 'react-router-dom';
import usePouch from '../../../../../../../Hooks/usePouch';

const TBody = () => {
  const { data } = useContext(TableContext);
  const {fetchById} = usePouch()
  const navigate = useNavigate()
  const [newData, setNewData] = useState([])
  const {id} = useParams()
  
  useEffect(()=>{
    async function getData(){
      let dta = await data.filter(function(item){
          return item.procedure_id === parseInt(id)
        })
        setNewData(dta)
    }
    getData()
  },[data])
  // let newData = data.filter(function(item){
  //   return item === id
  // })
  return (
    <>
      {newData.map((doc) => <TRow key={doc._id || doc.id} doc={doc} /> )}
    </>
  )
}

export default TBody